import CreateKyc from "../../components/admin/CreateKyc";

export default function CreateKycPage() {
  return <CreateKyc />;
}